import React from "react"
import { Link } from 'gatsby'
import Layout from "../components/layout"
import SEO from "../components/seo"

const LinksPage = () => (
  <Layout>
    <SEO title="Links" />
    <div 
      style={{
        margin: `5vw auto`,
        maxWidth: "70vw",
        padding: `0px 1.0875rem 1.45rem`,
        paddingTop: 0
      }}
    >
      <h2 style={{margin: "1rem auto", textAlign:"center"}}>HELPFUL LINKS FOR HUNTERS</h2>
      <a href="https://tpwd.texas.gov/regulations/outdoor-annual/hunting/seasons/statewide/" target="_blank" rel="noopener noreferrer">
          Texas Parks & Wildlife Department (TPWD) Hunting Seasons
      </a>
    </div>
  </Layout>
)

export default LinksPage